<template>
  <div
    class="tw-w-full tw-shadow tw-p-0 tw-m-0 tw-bg-gray-100"
    style="height: 100%; min-height: 200px;"
  >
    <b-card no-body class="tw-h-full tw-w-full tw-p-0 tw-m-0">
      <b-tabs card fill>
        <b-tab v-for="(tab, key) in data" :title="key" :key="key" ref="canvasContainer" :active="key === defaultSelected">
          <h6 class="tw-font-bolder tw-mb-0 text-center">
            Positive Infections
          </h6>
          <br>

          <div
            class="tw-m-4 tw-p-2 tw-border-l-8 tw-shadow-xl tw-border-red-500 tw-rounded tw-text-blue-dark"
          >
            <p class="tw-uppercase tw-font-bold">RAW</p>
            <p class="tw-text-3xl">{{ tab[0] }}</p>
          </div>

          <div
            class="tw-m-4 tw-p-2 tw-border-l-8 tw-shadow-xl tw-border-blue-500 tw-rounded tw-text-blue-dark"
          >
            <p class="tw-uppercase tw-font-bold">Screening</p>
            <p class="tw-text-3xl">{{ tab[1] }}</p>
          </div>

          <div
            class="tw-m-4 tw-p-2 tw-border-l-8 tw-shadow-xl tw-border-green-500 tw-rounded tw-text-blue-dark"
          >
            <p class="tw-uppercase tw-font-bold">Followup</p>
            <p class="tw-text-3xl">{{ tab[2] }}</p>
          </div>

        </b-tab>
      </b-tabs>

      <div v-if="user.is_superuser" class="tw-mt-auto tw-flex tw-justify-end tw-pr-5">
        <b-button :to="{name: 'table-microscopy'}" variant="outline-secondary">More</b-button>
      </div>

      <div class="tw-flex tw-justify-end">
        <info-popover>
          <template v-slot:title>
            Positive Infections
          </template>

          <p>Shows how many subjects have been infected.</p>

          <h5>SCREENING</h5>
          <p>How many subjects infected during screening.</p>

          <h5>FOLLOWUP</h5>
          <p>How many subjects infected during followup.</p>

          <h5>RAW</h5>
          <p>Total subjects infected (SCREENING + FOLLOWUP)</p>
        </info-popover>
      </div>
    </b-card>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import {
    mapState
} from 'vuex';

export default {
  mixins: [],
  computed: {
    ...mapState("user", ['user']),
  },
  data: function() {
    return {
      data: {
      },
      defaultSelected: "Cohort 2"
    };
  },
  created: function() {},
  mounted: function() {
    this.get();
  },
  methods: {
    get: function() {
      const that = this;
      HTTP.get("/kenya/metrics/positive-infections")
        .then(response => {
            that.data = response.data;
        })
        .catch(error => {
          HandleErrors.HandleErrors(error);
        });
    }
  }
};
</script>

<style>
nav.card-header {
  border-bottom: none;
  padding: 0.5rem 0 0 0;
}
ul.nav.nav-tabs {
  padding: 0 0.5rem;
}
ul.nav.nav-tabs li.nav-item {
  font-size: 0.7rem;
}
ul.nav.nav-tabs a.nav-link {
  padding: 0.35rem 0.5rem;
}

.small-number {
  font-size: 1.5vw;
}

.big-number {
  font-size: 2vw;
}

.small-text {
  font-size: 1vw;
}

.big-text {
  font-size: 1.5vw;
}
</style>
